import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27cfaabd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-full text-center flex px-4" }
const _hoisted_2 = { class: "text-xl" }
const _hoisted_3 = { class: "text-xl" }
const _hoisted_4 = { class: "text-xl" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-full" }, null, -1))
const _hoisted_6 = { class: "flex ml-2" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "ml-2 mr-2 my-4" }
const _hoisted_9 = {
  class: "text-xl text-gray-800 dark:text-dark-text",
  style: {"user-select":"text"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDown = _resolveComponent("DropDown")!
  const _component_IconForm = _resolveComponent("IconForm")!
  const _component_OutlinedIconTextButton = _resolveComponent("OutlinedIconTextButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["w-full headerSize bg-white dark:bg-dark-400 dark:border-dark-200", {
      'border-b': _ctx.dashboardModalStatePresenter.tabState.value !== 'COURSE'
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: _normalizeClass(["px-8 my-3 rounded cursor-pointer focus:outline-none", {
          'bg-gray-200 dark:bg-dark-10 text-arena-lighter': _ctx.dashboardModalStatePresenter.tabState.value === 'OVERVIEW'
        }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.click(`OVERVIEW`)))
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('message.overview')), 1)
      ], 2),
      _createElementVNode("button", {
        class: _normalizeClass(["px-8 my-3 rounded cursor-pointer focus:outline-none", {
          'bg-gray-200 dark:bg-dark-10 text-arena-lighter': _ctx.dashboardModalStatePresenter.tabState.value === 'DAILY'
        }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.click(`DAILY`)))
      }, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('message.daily')), 1)
      ], 2),
      _createElementVNode("button", {
        class: _normalizeClass(["px-6 my-3 rounded cursor-pointer focus:outline-none", {
          'bg-gray-200 dark:bg-dark-10 text-arena-lighter': _ctx.dashboardModalStatePresenter.tabState.value === 'COURSE'
        }]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.click(`COURSE`)))
      }, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('message.course')), 1)
      ], 2),
      _hoisted_5,
      _createVNode(_component_DropDown, {
        itemList: _ctx.items,
        selected: _ctx.changeProgramLanguage,
        selectedIndex: _ctx.nested.selectedIndex.value,
        style: {"margin":"11px 0 12px 8px"}
      }, null, 8, ["itemList", "selected", "selectedIndex"]),
      _createVNode(_component_IconForm, {
        class: "shadow-md ml-2",
        height: '37px',
        margin_bottom: '10px',
        margin_top: '11px',
        placeholder: _ctx.$t('message.enterOtherUser'),
        onEnterForm: _ctx.enterForm
      }, null, 8, ["placeholder", "onEnterForm"]),
      _createVNode(_component_OutlinedIconTextButton, {
        border_radius: 1,
        class: "cursor-pointer",
        dark_color_list: [
          'text-dark-text',
          'border-dark-200',
          'hover:bg-dark-800',
          'active:text-dark-10',
          'active:bg-dark-800'
        ],
        icon: 'delete',
        padding_left: 4,
        padding_right: 6,
        style: {"margin":"12px 0 11px 8px"},
        text: _ctx.$t('message.clear'),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clear()))
      }, null, 8, ["text"]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.hasAvatarImage)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              alt: "user icon",
              class: _normalizeClass(["border rounded-full mb-2", _ctx.isLightMode() ? 'image-style' : 'image-style-dark']),
              src: _ctx.initDashboardUser.avatar,
              style: {"user-drag":"none","margin-top":"10px"}
            }, null, 10, _hoisted_7))
          : (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: _normalizeClass(["material-icons mb-2", _ctx.isLightMode() ? 'image-style' : 'image-style-dark']),
              style: {"margin-top":"10px"}
            }, " account_circle ", 2)),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.initDashboardUser.id), 1)
        ])
      ])
    ])
  ], 2))
}